"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gallon = exports.MilliLiter = exports.Liter = exports.HundredCubicFeet = exports.CubicFeet = exports.CubicInch = exports.CubicCentiMeter = exports.CubicMeter = void 0;
var uom_1 = require("uom");
var length_1 = require("./length");
var unit_cubed_1 = require("../unit-cubed");
/** The metric unit for volume quantities ( <code>m³</code> ). */
exports.CubicMeter = unit_cubed_1.Cubed("CubicMeter", uom_1.BaseUnits.Meter);
// Volume
exports.CubicCentiMeter = unit_cubed_1.Cubed("CubicCentiMeter", length_1.CentiMeter);
exports.CubicInch = unit_cubed_1.Cubed("CubicInch", length_1.Inch);
exports.CubicFeet = unit_cubed_1.Cubed("CubicFeet", length_1.Foot);
exports.HundredCubicFeet = uom_1.Unit.timesNumber("HundredCubicFeet", 100.0, exports.CubicFeet);
exports.Liter = uom_1.Unit.divideNumber("Liter", 1000.0, exports.CubicMeter);
exports.MilliLiter = uom_1.UnitPrefix.Milli("MilliLiter", exports.Liter);
exports.Gallon = uom_1.Unit.timesNumber("Gallon", 3.785, exports.Liter);
//# sourceMappingURL=volume.js.map